import { hc } from "hono/client";
import type { App } from "~w/worker";

export const client = hc<App>(window.location.origin);
